import { Component, HostListener, OnInit, TemplateRef } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from "@syncfusion/ej2-angular-richtexteditor";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { marker as TRANSLATE_ME } from "@biesbjerg/ngx-translate-extract-marker";
import { CrudService } from "../../Services/crud.service";
import { DeleteConfirmationDialogComponent } from "../delete-confirmation-dialog/delete-confirmation-dialog.component";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { FormStateService } from "src/app/Services/form.service";

@Component({
  selector: "app-add-renew-license",
  templateUrl: "./add-renew-license.component.html",
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService],
  standalone: false,
  styles: [
    `
      ::ng-deep .mat-mdc-menu-panel {
        min-width: 50px !important;
      }
    `,
  ],
})
export class AddRenewLicenseComponent implements OnInit {
  form: UntypedFormGroup;
  state = false;
  submitted = false;
  showForm = false;
  data: [];
  licenseManagementId: any;
  currentLicense;
  licenseList = [];
  paymentFrequencyList = [
    { label: "Free", value: "free" },
    { label: "Monthly", value: "monthly" },
    { label: "Annual", value: "annual" },
  ];

  closeResult = "";

  public toolbarSettings: object = {
    items: [
      "Bold",
      "Italic",
      "Underline",
      "FontColor",
      "JustifyLeft",
      "JustifyCenter",
      "JustifyRight",
      "JustifyFull",
      "Formats",
      "Undo",
      "Redo",
      "SourceCode",
    ],
  };

  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private dialog: MatDialog,
    private modalService: NgbModal,
    private formStateService: FormStateService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
    this.createLicenseManagement = this.createLicenseManagement.bind(this);
    this.getLicenseManagementData = this.getLicenseManagementData.bind(this);
    this.getLicenseManagementData();
    this.getLicenseList = this.getLicenseList.bind(this);
    this.getLicenseList();
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      name: ["", Validators.required],
      displayName: ["", Validators.required],
      paymentFrequency: ["", Validators.required],
      amount: [
        "",
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      applicableAmount: [
        "",
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      taxAmount: [
        "",
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      totalAmount: [
        "",
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      discount: [
        "",
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      description: ["", Validators.required],
      features: ["", Validators.required],
      validFrom: ["", Validators.required],
      validUpto: ["", Validators.required],
    });
    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.formStateService.setFormDirty();
      }
    });
  }
  onStatusChange(item: any) {
    // You can call an API, update the database, etc.
    // Example:
    // this.myService.updateStatus(item.id, item.status).subscribe(...);
  }
  getLicenseManagementData() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        self.data = response;
      },
      "licenseModules"
    );
  }

  toggleDisable() {
    if (this.form.disabled) {
      this.form.enable();
    } else {
      this.form.disable();
    }
  }

  onChange(event) {
    this.form.markAsDirty();
    this.state = event.currentValue;
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.form.controls;
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  onSubmit() {
    let self = this;
    this.submitted = true;

    // stop here if form is invalid
    if (this.form.invalid) return;

    // submit API call
    var payload = this.form.value;
    payload.status = this.state;
    payload.validFrom = new Date(this.form.value.validFrom)
      .toISOString()
      .split("T")[0];
    payload.validUpto = new Date(this.form.value.validUpto)
      .toISOString()
      .split("T")[0];

    if (self.licenseManagementId) {
      self.crudService.update(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.toastr.success(
              "License has been updated successfully.",
              "Success"
            );
            self.getLicenseManagementData();
            self.getLicenseList();
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
            self.licenseManagementId = null;
            self.closeModal();
          }
        },
        "licenseModules/" + self.licenseManagementId
      );
    } else {
      self.crudService.post(
        payload,
        function (response) {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            self.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            self.toastr.success(
              "License has been created successfully.",
              "Success"
            );
            self.getLicenseManagementData();
            self.getLicenseList();
            self.form.markAsPristine();
            self.formStateService.clearFormDirty();
            self.closeModal();
          }
        },
        "licenseModules"
      );
    }
  }

  onReset() {
    if (!this.licenseManagementId) {
      this.submitted = false;
      this.state = true;
      this.form.reset();
      this.formStateService.clearFormDirty();
    } else {
      this.submitted = false;
      this.state = this.currentLicense.status;
      this.form.patchValue({
        ...this.currentLicense,
        validFrom: this.formatDate(this.currentLicense.validFrom),
        validUpto: this.formatDate(this.currentLicense.validUpto),
      });
      this.formStateService.clearFormDirty();
    }
  }

  toggleForm(licenseManagement: any) {
    this.showForm = !this.showForm;
    if (licenseManagement) {
      this.licenseManagementId = licenseManagement.id;
      this.state = licenseManagement.status;
      this.form.patchValue({
        ...licenseManagement,
        validFrom: this.formatDate(licenseManagement.validFrom),
        validUpto: this.formatDate(licenseManagement.validUpto),
      });
    }
  }

  getLicenseList() {
    let self = this;
    self.crudService.get(
      null,
      function (response) {
        if (
          response.error &&
          response.error.error &&
          response.error.error.message
        ) {
          self.licenseList = [];
          self.toastr.error(response.error.error.message, "Invalid Operation");
        } else {
          if (response.length) {
            self.licenseList = response;
          } else {
            self.licenseList = [];
          }
        }
      },
      "licenseModules"
    );
  }

  openDeleteConfirmationDialog(id): void {
    const dialogRef = this.dialog.open(DeleteConfirmationDialogComponent, {
      width: "600px",
      panelClass: "custom-bg",
      data: {
        title: this.translateService.instant("Form.DeleteLicense"),
        paragraph: this.translateService.instant("Form.DeleteLicenseMsg"),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.crudService.delete(
          null,
          (response) => {
            if (
              response.error &&
              response.error.error &&
              response.error.error.message
            ) {
              this.toastr.error(
                response.error.error.message,
                "Invalid Operation"
              );
            } else {
              this.toastr.success(
                "License has been deleted successfully.",
                "Success"
              );
              this.getLicenseManagementData();
              this.getLicenseList();
            }
          },
          "licenseModules/" + id
        );
      }
    });
  }
  createLicenseManagement() {
    this.licenseManagementId = undefined;
    this.state = false;

    this.submitted = false;
    this.form.reset();
    this.showForm = true;
  }

  open(content: TemplateRef<any>) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        backdrop: "static",
        keyboard: false,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return "by pressing ESC";
      case ModalDismissReasons.BACKDROP_CLICK:
        return "by clicking on a backdrop";
      default:
        return `with: ${reason}`;
    }
  }

  private formatDate(date: string): string {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
}
